import { render, staticRenderFns } from "./AppDialog.vue?vue&type=template&id=0c9ec227&scoped=true&"
import script from "./AppDialog.vue?vue&type=script&lang=js&"
export * from "./AppDialog.vue?vue&type=script&lang=js&"
import style0 from "./AppDialog.vue?vue&type=style&index=0&id=0c9ec227&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9ec227",
  null
  
)

export default component.exports